import templateUrl from './lead-office-team-list.component.html';

export const LeadOfficeTeamListComponent = {
    controller: LeadOfficeTeamController,
    controllerAs: "vm",
    templateUrl
}

function LeadOfficeTeamController($uibModal, utilityService, leadOfficeTeamService) {
    'ngInject';
    const vm = this;

    vm.$onInit = activate;

    vm.columns;
    vm.sortColumns = [{ field: "EffectiveDate", dir: -1 }]; // Default
    vm.isSortingByField = isSortingByField;
    vm.columnClass = columnClass
    vm.pageNumber = 1;
    vm.pageSize = 10;
    vm.onSetSort = onSetSort;
    vm.sortLeadOfficeTeams = sortLeadOfficeTeams;
    vm.leadOfficeTeams = [];
    vm.prestineLeadOfficeTeams = [];
    vm.onEdit = onEdit;
    vm.filters = {};
    vm.filterLeadOfficeTeams = filterLeadOfficeTeams;
    vm.onDelete = onDelete;
    function activate() {
        vm.columns = [
            {
                title: "Office Name",
                field: "OfficeName",
                sortable: true
            },
            {
                title: "Display Name",
                field: "DisplayName",
                sortable: true
            },
        ];

        loadLeadOfficeTeams();
    }
    function loadLeadOfficeTeams() {
        utilityService.showLoading();
        leadOfficeTeamService.retrieveLeadOfficeTeams()
            .then(function (leadOfficeTeams) {
                vm.leadOfficeTeams = leadOfficeTeams;
            }).catch(function (ex) {
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                if (vm.leadOfficeTeams) {
                    if ((vm.pageNumber - 1) * vm.pageSize >= vm.leadOfficeTeams.length) {
                        vm.pageNumber = 1;
                    }
                }
                utilityService.hideLoading();
            });
    }

    function getColumn(field) {
        return vm.sortColumns.filter(function (column) {
            return column.field === field;
        })[0];
    }

    function onSetSort(sortField) {
        // TODO: Refactor or use an existing library to handle data table functionality.
        let sortColumn = vm.sortColumns.filter(function (sortColumn) {
            return sortColumn.field === sortField.field;
        })[0];
        if (!sortColumn) {
            // Start dir at -1 (descending) so that it toggles to ascending order by default.
            sortColumn = { field: sortField.field, dir: -1 };
            vm.sortColumns.splice(0, vm.sortColumns.length);
            vm.sortColumns.unshift(sortColumn);
        }
        sortColumn.dir *= -1;
        vm.sortLeadOfficeTeams(vm.leadOfficeTeams);

    }

    function sortLeadOfficeTeams(leadOfficeTeams) {

        return leadOfficeTeams.sort(function (a, b) {
            return vm.sortColumns.reduce(function (comparison, column) {
                // Go through all columns in order and return the value
                // of the first comparison that broke equality (ie, returned non-0).
                if (comparison === 0) {
                    // Still equal.
                    if (a[column.field] < b[column.field]) {
                        return -1 * column.dir;
                    } else if (a[column.field] > b[column.field]) {
                        return column.dir;
                    }
                }
                return comparison;
            }, 0);
        })
    }

    function isSortingByField(field) {
        const column = getColumn(field);
        return !!column;
    }

    function columnClass(field) {
        const column = getColumn(field);
        if (!column) {
            return {};
        }

        return {
            'glyphicon fas fa-sort-amount-down-alt': column.dir > 0,
            'glyphicon fas fa-sort-amount-down': column.dir < 0
        };
    }
    function filterLeadOfficeTeams(leadOfficeTeam) {

        return (!vm.filters.DisplayName || utilityService.containsInvariant(
            leadOfficeTeam.DisplayName, vm.filters.DisplayName))
            && (!vm.filters.OfficeName || utilityService.containsInvariant(
                leadOfficeTeam.OfficeName, vm.filters.OfficeName))


    }

    function onEdit(leadOfficeTeam) {
        $uibModal.open({
            template: '<div class="modal-header"><h1>New Team</h1></div>'
                + '<div class="modal-body">'
                + '<apex-edit-lead-office-team  lead-office-team="vm.leadOfficeTeam" after-submit="vm.afterSubmit(leadOfficeTeam)"   ></apex-edit-lead-office-team>'
                + '</div>'
                + '<div class="modal-footer"><button class="btn btn-plain float-right" ng-click="vm.close()">Close</button></div>',
            controller: function ($uibModalInstance, leadOfficeTeam) {
                'ngInject';
                this.leadOfficeTeam = !leadOfficeTeam ? null : leadOfficeTeam;

                this.afterSubmit = function (leadOfficeTeam) {
                    $uibModalInstance.close(leadOfficeTeam);
                };
                this.close = function () {
                    $uibModalInstance.dismiss();
                    loadLeadOfficeTeams();
                };
            },
            controllerAs: "vm",
            resolve: {
                leadOfficeTeam: leadOfficeTeam

            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        }).result.then(function (leadOfficeTeam) {
            loadLeadOfficeTeams();
        }).then(function () {
            utilityService.hideLoading();
        })
    }
    function onDelete(leadOfficeTeam) {

        utilityService.showLoading();
        leadOfficeTeamService.deleteLeadOfficeTeam(leadOfficeTeam.OfficeTeamID)
            .then(function (leadOfficeTeams) {
                loadLeadOfficeTeams();
            }).catch(function (ex) {
                alert("Delete failed: " + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                utilityService.hideLoading();
            });

    }
}
